import React from 'react';
import styled from 'styled-components';

import InitialSelect from 'hive-admin/src/components/Input/Select';

import tests from '../helpers/tests';
import clickAnchor from '../helpers/clickAnchor';

const Select = styled(props => <InitialSelect {...props} open={false} />)`

`;

const fields = [
  ['FieldTitle', {
    title: 'Sending',
    // eslint-disable-next-line max-len
    subtitle: 'Test system SMS services by sending arbitrary messages using the button below.',
  }],
  ['ActionWithFormModal', {
    name: 'sms-send',
    title: 'Send SMS',
    fields: [
      ['FieldSelect', {
        name: 'to',
        label: 'To',
        mode: 'tags',
        // eslint-disable-next-line max-len
        placeholder: 'International phone numbers (+971...) separated by space',
        tokenSeparators: [' '],
        Component: Select,
      }],
      ['FieldSelect', {
        name: 'provider',
        label: 'Provider',
        initialValue: null,
        choices: [
          { value: null, label: 'Auto' },
          { value: 'twilio', label: 'Twilio' },
          { value: 'rivet', label: 'Rivet' },
        ],
      }],
      ['FieldTextArea', {
        name: 'body',
        label: 'Message',
        placeholder: 'Message',
        initialValue: 'Test',
      }],
    ],
    actions: [
      ['ActionWithRequest', {
        name: 'send',
        title: 'Send',
        skip: [],
        getRequestConfig: props => ({
          url: 'development/sms/send',
          method: 'POST',
          data: props.form.getFieldsValue(),
        }),
      }],
    ],
  }],
  ['FieldTitle', {
    title: 'Customers',
  }],
  ['ActionWithRequest', {
    name: 'getCustomers',
    title: 'Create Customers',
    skip: [],
    getRequestConfig: () => ({
      url: 'development/create-existing-customers',
      method: 'POST',
    }),
  }],
  ['FieldTitle', {
    title: 'Store Domains Report',
  }],
  ['ActionWithRequest', {
    name: 'getStoreDomainsReport',
    title: 'Store Domains Report',
    skip: [],
    getRequestConfig: () => ({
      url: 'development/store-domains-report',
      method: 'POST',
    }),
  }],
  ['FieldTitle', {
    title: 'Content Builder',
  }],
  ['ActionWithRequest', {
    name: 'removeContentBuilderCache',
    title: 'Drop',
    skip: [],
    getRequestConfig: () => ({
      url: 'contentbuilder/empty',
      method: 'POST',
    }),
  }],
  ['FieldTitle', {
    title: 'Files',
  }],
  ['ActionWithRequest', {
    name: 'developmentProcessFilesDeep',
    title: 'Process Files Deep',
    skip: [],
    getRequestConfig: () => ({
      url: 'development/process-files-deep',
      method: 'POST',
    }),
  }],
  // ['ActionWithRequest', {
  //   name: 'developmentRestoreImages',
  //   title: 'Restore Images',
  //   skip: [],
  //   getRequestConfig: () => ({
  //     url: 'development/restore-images',
  //     method: 'POST',
  //   }),
  // }],
  // // ['Action', {
  // ['ActionWithRequest', {
  //   name: 'developmentGetImagesExifOrientations',
  //   title: 'Get Images Exif Orientations',
  //   skip: [],
  //   // onClick: (props) => clickAnchor({
  //   //   url: `${props.restBaseServer}/development/get-images-exif-orientations`,
  //   //   query: {
  //   //     access_token: props.client.getAccessToken(),
  //   //   },
  //   // }),
  //   getRequestConfig: () => ({
  //     url: 'development/get-images-exif-orientations',
  //     method: 'POST',
  //   }),
  // }],
  // // ['Action', {
  // ['ActionWithRequest', {
  //   name: 'developmentSetImagesExifOrientations',
  //   title: 'Set Images Exif Orientations',
  //   skip: [],
  //   // onClick: (props) => clickAnchor({
  //   //   url: `${props.restBaseServer}/development/get-images-exif-orientations`,
  //   //   query: {
  //   //     access_token: props.client.getAccessToken(),
  //   //   },
  //   // }),
  //   getRequestConfig: () => ({
  //     url: 'development/set-images-exif-orientations',
  //     method: 'POST',
  //   }),
  // }],
  ['FieldTitle', {
    title: 'Miscellaneous',
  }],
  ['Action', {
    name: 'getStoresDomainsDns',
    title: 'Get Stores Domains DNS',
    skip: [],
    onClick: (props) => clickAnchor({
      url: `${props.restBaseServer}/development/get-stores-domains-dns`,
      query: {
        access_token: props.client.getAccessToken(),
      },
    }),
  }],
  ['ActionWithRequest', {
    name: 'expireablesSendAll',
    title: 'Expireables / Send All',
    skip: [],
    getRequestConfig: () => ({
      url: 'stores/expireables/send-all',
      method: 'POST',
    }),
  }],
  // ...[
  //   ['Json'],
  //   ['Csv'],
  //   ['CsvAlt', 'CSV ALT'],
  // ].map(([suffix, titleSuffix]) => ['Action', {
  //   name: `fixMissingOrdersGetStoresInfo${suffix}`,
  //   title: `Get Stores Info - ${(titleSuffix || suffix).toUpperCase()}`,
  //   skip: [],
  //   onClick: (props) => clickAnchor({
  //     url: `${props.restBaseServer}/development/get-stores-info`,
  //     query: {
  //       download: suffix.toLowerCase(),
  //       access_token: props.client.getAccessToken(),
  //     },
  //   }),
  // }]),
  // ...[
  //   ['Json'],
  //   ['Csv'],
  //   // ['CsvAlt', 'CSV ALT'],
  // ].map(([suffix, titleSuffix]) => ['Action', {
  //   name: `getMissingOrdersCustomers${suffix}`,
  //   title: `Get Missing Orders Customers - ${
  //     titleSuffix || suffix.toUpperCase()
  //   }`,
  //   skip: [],
  //   onClick: (props) => clickAnchor({
  //     url: `${props.restBaseServer}/development/get-missing-order-customers`,
  //     query: {
  //       download: suffix.toLowerCase(),
  //       access_token: props.client.getAccessToken(),
  //     },
  //   }),
  // }]),
];

export default [
  'PageSingle',
  {
    id: 'devtools',
    // icon: 'code',
    title: 'Dev Tools',
    path: '/devtools',
    label: 'Dev Tools',
    headerTitle: 'Dev Tools',
    renderHeaderTitle: () => 'Dev Tools',
    hidden: false,
    activity: 'edit',
    url: '/development',
    redirect: [['redirect.unauthorized']],
    fields,
    actions: [],
    skip: [tests.viewerIsNotThehiveRsAdmin],
  },
];
